/**
 * BLoc sliders object
 */
var sliders = {

  params : {
		sliderContainer: '',
    slidesContent: [],
    slides: '',
    initCalled: false
	},

	init : function(options) {
    that = this;
		this.params = $.extend(this.params,options);


    if (!this.params.initCalled) {
      this.params.initCalled = true;

      for (var i = 0; i < $(this.params.slides).length; i++) {
        var link = $(this.params.slides)[i];
        sliders.handleClick(link, i);
      }
    }

    this.params.slides.each(function(index,value) {
      var attr = $(this).attr("data-contenu"),
          slidesContent = that.params.slidesContent[attr];
      if(!slidesContent) {
        slidesContent = that.params.slidesContent[attr] = [];
      }
      slidesContent.push(this);
    });

    this.params.sliderContainer.each(function(index, value){
      var sliderInner = $(this);
      var attr = $(this).attr("data-conteneur");
      for(var item in that.params.slidesContent) {
        sliderInner.append(that.params.slidesContent[attr]);
      }
      $(this).children(":first").addClass("active");
    });

  },

  handleClick : function(link, index) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      slider.goToTab(index);
    });
  },

  goToTab : function(index) {
    if (index >= 0 && index <= $(this.params.tab).length) {
      $(this.params.tab).removeClass('active');
      $(this.params.tab)[index].className += ' active';
      $(this.params.tabPane).removeClass('active');
      $(this.params.tabPane)[index].className += ' active';
    }
  }
}
